import { useQuery } from "@tanstack/react-query";
import {
  getAdminDailySalesApi,
  getResellerDailySalesApi,
} from "../api/adminDailySalesApi";

export const ADMIN_DAILY_SALES_QUERY_KEY = ["admin", "dailySales"];
export const RESELLER_DAILY_SALES_QUERY_KEY = ["reseller", "dailySales"];

export const useGetAdminDailySalesQuery = (
  fromDate: string,
  toDate: string,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: [...ADMIN_DAILY_SALES_QUERY_KEY, fromDate, toDate],
    queryFn: () => getAdminDailySalesApi(fromDate, toDate),
    enabled: enabled,
  });
};

export const useGetResellerDailySalesQuery = (
  resellerId: string | undefined,
  fromDate: string,
  toDate: string
) => {
  return useQuery({
    queryKey: [
      ...RESELLER_DAILY_SALES_QUERY_KEY,
      resellerId,
      fromDate,
      toDate,
    ],
    queryFn: () =>
      getResellerDailySalesApi(
        resellerId!,
        fromDate,
        toDate
      ),
    enabled: !!resellerId,
  });
};

export const useDailySalesQuery = (
  fromDate: string,
  toDate: string,
  resellerId?: string
) => {
  const adminQuery = useGetAdminDailySalesQuery(fromDate, toDate, !resellerId);
  const resellerQuery = useGetResellerDailySalesQuery(
    resellerId,
    fromDate,
    toDate
  );
  return resellerId ? resellerQuery : adminQuery;
};
